let construct_url = (baseUrl, params) => {
    const urlObject = new URL(baseUrl);

    for (const [param, value] of Object.entries(params)) {
        urlObject.searchParams.set(param, value);
    }

    return urlObject.toString();
};

export default construct_url;
